<template>
  <div class="colophon_wrapper">
    <InfoButton />
    <p class="typo-medium">
      Psssst!  Hey Kid!<br /><br />
      Write a program for when you are a home alone and there is an unknown amount of Candy and Apples on the table. Your parents are away but can come home anytime.<br><br>
      You probably want to eat as much Candy as possible.<br />
      But your parents want you to eat the apples first.<br /><br />
      Use commands, functions, loops and logical conditions. Think of:<br />
      <span class="code indented-3">Function: ‘parents are not home’<br />
      Function: ‘eat all candy’<br /><br /></span>
      There is not one single good solution. Code the future.
    </p>
    <button class="button previous-button bottom left" @click="goToPreviousSlide">←</button>
    <button class="button next-button bottom right" @click="goToNextSlide"><img class="weird-arrow" :src="wierdArrow" alt="" /></button>
  </div>
</template>

<script>
import wierdArrow from '@/assets/weirdArrow.svg'
import InfoButton from '@/components/InfoButton'

export default {
  name: 'Colophon',
  components: {
    InfoButton,
  },
  props: [
    'slider',
    'index',
  ],
  data() {
    return {
      wierdArrow,
    }
  },
  created() {
    this.$eventHub.$on('slideSelected', this.slideSelected)
  },
  beforeDestroy() {
    this.$eventHub.$off('slideSelected')
  },
  methods: {
    slideSelected() {
      // console.log(this.slider.selectedIndex(), this.index)
      if (this.slider.selectedIndex() === this.index) {
        // console.log('we are on the colophon')
        this.slider.options.draggable = true
        this.$store.dispatch('setCandyCodesComplete')
      }
    },
    goToNextSlide() {
      this.slider.next()
    },
    goToPreviousSlide() {
      this.slider.previous()
    },
  },
}
</script>

<style lang="scss">

@mixin small {
  @media (max-width: 320px) {
    @content;
  }
}

@mixin tablet {
  @media (min-width: 768px) {
    @content;
  }
}

@mixin desktop {
  @media (min-width: 1300px) {
    @content;
  }
}

.colophon_wrapper {
  height: 100%;
  width: 100%;
  background: black;


  p {

      padding: 15px 50px 50px 20px;

      @include tablet {
        padding: 32px 130px 60px 58px;
      }

      @include desktop {
        padding: 37px 0 0 58px;
        max-width: 1100px;
      }

  }


  .button.next-button.bottom.right {
      bottom: -1px;


      @include desktop {
        bottom: -2px;
      }

    .weird-arrow {
      height: 21px;



      @include tablet {
        height: 30px;
      }

      @include desktop {
        height: 37px;
      }
    }
  }

}




</style>



// WEBPACK FOOTER //
// src/components/Colophon.vue